export const QWIKBOX_STORAGE_BASE_URL = 'https://storage.qwikcut.com';
